import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

export function isMetricsEnabled(): boolean {
  const sessionManagementService = getSessionManagementServiceInstance();
  return sessionManagementService.isMetricsEnabledOnSite() && FeatureFlags.metricsSpaceEnabled;
}

export function isMetricsRequestAccessDialogEnabled(): boolean {
  return FeatureFlags.requestAccessDialogEnabled;
}
